webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(268);


/***/ },

/***/ 166:
/***/ function(module, exports) {

	"use strict";
	
	exports.INCREMENT_COUNTER = 'App/INCREMENT_COUNTER';
	exports.DECREMENT_COUNTER = 'App/DECREMENT_COUNTER';
	exports.LOGIN_USER_PENDING = 'App/LOGIN_USER_PENDING';
	exports.LOGIN_USER_SUCCESS = 'App/LOGIN_USER_SUCCESS';
	exports.LOGIN_USER_ERROR = 'App/LOGIN_USER_ERROR';
	exports.LOGOUT_USER = 'App/LOGOUT_USER';
	exports.FORM_RESET = 'redux-form/RESET';

/***/ },

/***/ 167:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var redux_1 = __webpack_require__(104);
	
	var _require = __webpack_require__(153),
	    routerReducer = _require.routerReducer;
	
	var formReducer = __webpack_require__(606).reducer;
	var counter_1 = __webpack_require__(270);
	var session_1 = __webpack_require__(271);
	var rootReducer = redux_1.combineReducers({
	    session: session_1.default,
	    counter: counter_1.default,
	    routing: routerReducer,
	    form: formReducer
	});
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = rootReducer;

/***/ },

/***/ 261:
/***/ function(module, exports) {

	"use strict";
	
	var data1 = [{
	    id: '60b7d196-64bc-426f-a0ba-a6bb22683f43',
	    img: 'http://az616578.vo.msecnd.net/files/2016/02/10/635907389307772482120429611_siblings81809slw.jpg',
	    question: 'How many siblings do you have, and what do they do?',
	    color: 'white',
	    depth: 1,
	    tags: [{ family: true }]
	}, {
	    id: '5c64a1aa-56b3-4283-800f-353d14c5eb1d',
	    img: 'http://cosmouk.cdnds.net/16/03/980x490/landscape-1453286906-143479396.jpg',
	    question: 'Do you consider yourself an introvert or extravert?',
	    color: 'white',
	    depth: 1,
	    tags: [{ personality: true }]
	}, {
	    id: 'cecdc61f-d1f5-417a-9ee9-04aeb503d825',
	    img: "http://img1.rnkr-static.com/list_img_v2/1518/161518/full/countries-ruled-by-a-democracy-u1.jpg",
	    question: "Do you consider yourself a left- or right-leaning on financial and social issues?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        politics: true
	    }, {
	        finance: true
	    }]
	}, {
	    id: '5fecdcc4-caa2-4098-9201-a13c80644209',
	    img: "https://i.ytimg.com/vi/IUDfxGZ6pPI/maxresdefault.jpg",
	    question: "What music genres do you like? Any genres you don't like?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        interests: true
	    }]
	}, {
	    id: '467196a3-7d4f-4873-bea3-349fed65367d',
	    img: "http://more-sky.com/data/out/8/IMG_272735.jpg",
	    question: "Are you a cat person or dog person?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }, {
	        personality: true
	    }]
	}, {
	    id: '087638d7-46c9-4169-a1f8-4dc4b7e0f563',
	    img: "http://www.betterretailing.com/wp-content/uploads/2015/03/ice-cream-people-696x313.jpg",
	    question: "What's your favorite flavor of ice cream?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }]
	}, {
	    id: '48c917cd-95b6-450a-acb3-fc0b12027445',
	    img: "https://s3.amazonaws.com/usc-cache.salvationarmy.org/f3e44f79-1bb7-488f-b09e-ac13d9ab3b9a_kids-music.jpg",
	    question: "Do you play a musical instrument?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        abilities: true
	    }]
	}, {
	    id: 'f9f44156-7c2f-4bd4-bcec-4cbec25d1f18',
	    img: "http://www.livescience.com/images/i/000/034/021/original/shutterstock_102937733.jpg",
	    question: "What's your favorite season and why?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }]
	}, {
	    id: 'b79d00a8-eee0-4c4c-9ee4-6b2093d0f282',
	    img: "https://upload.wikimedia.org/wikipedia/commons/0/04/Oil_painting_palette.jpg",
	    question: "What's your favorite color?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }]
	}, {
	    id: 'f63402a3-dd89-45b7-823f-66dc1f462912',
	    img: "http://www.restaurantbusinessonline.com/sites/default/files/styles/731_x_411/public/takeout-food-boxes-to-go_0.jpg",
	    question: "What's your favorite drive-through or take-out meal?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }]
	}, {
	    id: '759169bb-c52a-4c48-a1bc-e098b1e67686',
	    img: "http://cdn.pcwallart.com/images/cool-alarm-clock-wallpaper-2.jpg",
	    question: "What do you do on a 'normal day'?  Start with 'I wake up, and...'  End with '...and then I go to sleep'.",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }, {
	        personality: true
	    }, {
	        interests: true
	    }]
	}, {
	    id: '1da32f97-cc75-4289-a6e9-bcbba26ea704',
	    img: "http://www.promobilewebsites.com.au/wp-content/uploads/sites/13/2014/01/person-searching-on-smartphone.jpg",
	    question: "What's your favorite social media channel?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }]
	}, {
	    id: '13160dee-c4fc-4ed4-b174-85bfdc6928db',
	    img: "http://dingo.care2.com/pictures/greenliving/1276/1275121.large.jpg",
	    question: "Do you have pets?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }]
	}, {
	    id: '86e9449b-31c1-44c9-bcc9-59f47d4501f3',
	    img: "https://www.doschdesign.com/images2/Red-DVI-People-Sports.jpg",
	    question: "Do you play or watch any sports?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }, {
	        interests: true
	    }]
	}, {
	    id: 'fc91aa5a-1c55-470b-8d37-49b3a439691f',
	    img: "http://addictionblog.org/wp-content/uploads/2011/06/Why-do-people-start-drinking-alcohol-Top-10-reasons2.jpg",
	    question: "Do you remember the first time you drank alcohol, smoked a cigarrette, or took drugs?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        history: true
	    }, {
	        preferences: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: '86729ecd-f1e9-43e9-918d-34f1281c6641',
	    img: "http://www.slate.com/content/dam/slate/articles/health_and_science/medical_examiner/2014/10/141002_MEDEX_AlcoholDrinking.jpg.CROP.promo-mediumlarge.jpg",
	    question: "When was the last time you drank, smoked a cigarette, or took drugs?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: 'de0efe5f-9d5f-4fe1-b12b-5ae01a91f110',
	    img: "https://www.mcminnlaw.com/assets/accident-car-ambulance.jpg",
	    question: "Have you ever been in a car accident?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        history: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: 'f2cbba5c-0ea3-4546-b509-39d09b2564a1',
	    img: "http://i.huffpost.com/gen/1447961/images/o-YOUNG-PEOPLE-TALKING-TO-OLD-PEOPLE-facebook.jpg",
	    question: "What age do you consider old?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        personality: true
	    }, {
	        preferences: true
	    }]
	}, {
	    id: '755d2849-92fc-445f-971a-b4f9edc3f7ed',
	    img: "https://thumbs.dreamstime.com/x/north-america-space-11512625.jpg",
	    question: "Do you have relatives in other states (or countries)? If so, which ones?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        family: true
	    }]
	}, {
	    id: '5d119dd4-1864-46f9-9631-1b1b9357a2f6',
	    img: "http://martintrench.com/wp-content/uploads/2014/11/Cup-of-coffee-coffee-17731301-1680-1050.jpg",
	    question: "Are you a morning person?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }, {
	        personality: true
	    }]
	}, {
	    id: 'a352cc73-8298-4adc-a4cd-57f0874c73f1',
	    img: "http://www.greentoys.com/sites/default/files/151023_GreenToys_Bestseller_Baby_0369_887x591.jpg",
	    question: "What were your favorite toys when you were younger?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        preferences: true
	    }, {
	        memory: true
	    }]
	}, {
	    id: '5a4eb4ed-c727-46ab-a069-f3ae4d205005',
	    img: "http://p2cdn4static.sharpschool.com/UserFiles/Servers/Server_3076632/Image/staff%20images/6th%20Grade/Tombs/Technology/School-Food.jpg",
	    question: "What's the first memory you have when you think of the words 'school lunch'?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        history: true
	    }, {
	        memory: true
	    }]
	}, {
	    id: '4b11beca-2dd5-4a6e-956e-4a2de93981d7',
	    img: "http://www.ronedmondson.com/wp-content/uploads/2012/06/little-boy-waiting1.jpg",
	    question: "What's something you remember looking forward to when you were young?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        memory: true
	    }, {
	        history: true
	    }, {
	        preferences: true
	    }]
	}, {
	    id: '8dfb576b-acaf-47fb-81f9-ccbc02a37e30',
	    img: "http://wallpapers-diq.org/wallpapers/11/Gas_Ring%2C_Water_Flame_Fantasy.jpg",
	    question: "What's a phase you went through?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        memory: true
	    }]
	}, {
	    id: 'cda15437-ccd1-4d8d-af2b-136b85e7dab4',
	    img: "http://discoveringalabama.org/wp-content/uploads/2012/04/geography-teacher-4.jpg",
	    question: "How do you think your teachers would have described you?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        memory: true
	    }, {
	        personality: true
	    }]
	}, {
	    id: '49fa864d-2d08-4b18-9a15-678077f1d364',
	    img: "http://www.childrensrights.org/wp-content/uploads/2014/09/2011-07-06_ri_blog_post_kids_blurry_running.jpg",
	    question: "What's a story you've heard about something you did when you were young?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        memory: true
	    }, {
	        family: true
	    }, {
	        history: true
	    }]
	}, {
	    id: '738393aa-3f88-4a6d-82f5-109ec2699e20',
	    img: "http://blogs.voanews.com/science-world/files/2014/01/wakingupfromanightmare.jpg",
	    question: "What's one of the scariest dreams you can remember having?",
	    color: "white",
	    depth: 1,
	    tags: [{
	        memory: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: '592982d2-0d8f-40e1-99e8-59020527cab1',
	    img: "https://stopandpraytv.files.wordpress.com/2015/03/sin-apple.jpg",
	    question: "What temptations would you be better off removing from your life?",
	    color: "white",
	    depth: 1,
	    tags: []
	}, {
	    id: '6b19b370-31eb-43ba-b935-14c8fcdc9f81',
	    img: "http://cdn.attackofthecute.com/January-04-2013-19-49-49-k.jpg",
	    question: "What activity do you never procrastinate on when it needs doing?",
	    depth: 1,
	    tags: [{ personality: true }]
	}, {
	    id: '2597c520-7a50-46ea-b089-88529af28fbd',
	    img: "http://www.guardyourhealth.com/wp-content/uploads/2014/05/160887834_1600x1000-800x500.jpg",
	    question: "What's something you enjoy doing for other people?",
	    depth: 1,
	    tags: [{ personality: true }, { interests: true }]
	}, {
	    id: '430cbd6b-ea1b-4131-bbe6-2b1db5d5021b',
	    img: "https://onlossandlove.files.wordpress.com/2015/01/little-girl-smiling.jpg",
	    question: "What's something you enjoy doing again and again?",
	    depth: 1,
	    tags: [{ interests: true }]
	}, {
	    id: 'baf4e6e7-9063-40ec-8f12-59c7f520f40d',
	    img: "https://media.mnn.com/assets/images/2015/03/women-laughing.jpg.653x0_q80_crop-smart.jpg",
	    question: "When did you last laugh so much it hurt?",
	    depth: 1,
	    tags: [{ personality: true }]
	}, {
	    id: 'd2fffd28-d6e7-4a1b-aa6d-156a1cd4c01f',
	    img: "http://46iz7l49slf33wb8i5o2x0r406.wpengine.netdna-cdn.com/wp-content/uploads/2014/10/cliff_wide-054d76bca17db78df42b4c95905b64cdc48bfe2a-s6-c30.jpg",
	    question: "If you woke up tomorrow with no fear, what would you do first?",
	    depth: 1,
	    tags: [{ personality: true }]
	}, {
	    id: '1034d784-b808-4a46-bb68-d43abd3c0ba3',
	    img: "http://www.planetware.com/photos-large/CAY/caribbean-best-beaches-pink-sand-beach.jpg",
	    question: "What's something that always leaves you wanting more?",
	    depth: 1,
	    tags: [{ interests: true }]
	}, {
	    id: 'ed01317e-40d4-4830-9c94-3505569ce285',
	    img: "http://s.hswstatic.com/gif/water-life-crop.jpg",
	    question: "What's the first childhood memory you think of when you hear the word 'Water'?",
	    depth: 1,
	    tags: [{ memory: true }]
	}, {
	    id: 'f75b4e14-adb7-48d1-9df9-cd74a7cf5325',
	    img: "https://static.pexels.com/photos/33688/delicate-arch-night-stars-landscape.jpg",
	    question: "What's the first childhood memory you think of when you hear the word 'Stars'?",
	    depth: 1,
	    tags: [{ memory: true }]
	}, {
	    id: '16b5a549-f432-4b30-8369-109c0f13981c',
	    img: "https://cdn.pastemagazine.com/www/articles/1roadtripmain.jpg",
	    question: "What's the first childhood memory you think of when you hear the word 'Car'?",
	    depth: 1,
	    tags: [{ memory: true }]
	}, {
	    id: '3017a2ad-14b1-461a-9f9f-b9f8b5f2cc8f',
	    img: "http://4.bp.blogspot.com/_-FEgefSk_mQ/TFeSdEZeJfI/AAAAAAAAAZc/N6SY6VUQX4s/s400/IMG_9467.JPG",
	    question: "What's the earliest school-related memory that comes to mind? (First day of school?)",
	    depth: 1,
	    tags: [{ memory: true }]
	}, {
	    id: '2864ba7a-b383-4223-ac6c-5b02d53a94d5',
	    img: "http://golf4good.org/wp-content/uploads/2016/05/dinner.jpg",
	    question: "Given the choice of anyone in the world, whom would you want as a dinner guest?",
	    depth: 1,
	    tags: [{ interests: true }]
	}, {
	    id: '09cd307f-0b33-4e34-8259-c353aba66195',
	    img: "https://www.serentespa.com/serentespawp/wp-content/uploads/Red-Carpet-Ready.jpg",
	    question: "Would you like to be famous? In what way?",
	    depth: 1,
	    tags: [{ personality: true }]
	}, {
	    id: '68abbc1f-b04b-4475-880c-a360ca75ed6b',
	    img: "https://c1.staticflickr.com/6/5821/21709019379_4c9f743339_b.jpg",
	    question: "Before making a telephone call, do you ever rehearse what you are going to say? Why?",
	    depth: 1,
	    tags: [{ personality: true }]
	}, {
	    id: 'f76d6c8b-d038-4c77-9fc9-9cb720261bf3',
	    img: "https://upload.wikimedia.org/wikipedia/commons/5/58/Sunset_2007-1.jpg",
	    question: "What would constitute a “perfect” day for you?",
	    depth: 1,
	    tags: [{ personality: true }, { preferences: true }]
	}, {
	    id: '1acbe3e0-49e9-48ea-b783-3b22d7f3c881',
	    img: "http://az616578.vo.msecnd.net/files/2015/12/19/6358614596527738711752945771_music.jpg",
	    question: "When did you last sing to yourself? To someone else?",
	    depth: 1,
	    tags: []
	}, {
	    id: '564c16f4-3142-4adc-bbbf-5865937a85f7',
	    img: "http://www.washington.edu/news/files/2014/01/elderly-man-teaches-grandson-about-chess.jpg",
	    question: "If you were to live to the age of 90 and retain the mind or body of a 30-year-old, which would you want?",
	    depth: 1,
	    tags: []
	}, {
	    id: 'bcda1f12-ae7f-48e3-9506-2142ece340f7',
	    img: "https://www.pickthebrain.com/blog/wp-content/uploads/2014/01/change-your-life.png",
	    question: "Take four minutes and tell your life story in as much detail as possible.",
	    depth: 1,
	    tags: [{ history: true }, { memory: true }]
	}, {
	    id: '90615aee-ebd1-441d-86ee-f42cd464446c',
	    img: "http://wallpaper-gallery.net/images/mountain-image/mountain-image-2.jpg",
	    question: "If you could wake up tomorrow having gained any one quality or ability, what would it be?",
	    depth: 1,
	    tags: []
	}];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = data1;

/***/ },

/***/ 262:
/***/ function(module, exports) {

	"use strict";
	
	var data2 = [{
	    id: '385bba4e-8d3c-4630-87c1-856bc6d81337',
	    img: 'https://s-media-cache-ak0.pinimg.com/originals/1f/97/9d/1f979db6e76458eed51f1464cd1f9db5.jpg',
	    question: 'If a crystal ball could tell you the truth about yourself, your life, or anything else, what would you want to know?',
	    depth: 2,
	    tags: [{
	        aspirations: true
	    }]
	}, {
	    id: '41e53003-d3d6-4546-8f73-c3d734d88df8',
	    img: 'http://www.billmarshjr.com/wp-content/uploads/2015/08/dream1.jpg',
	    question: 'Is there something that you’ve dreamed of doing for a long time? Why haven’t you done it?',
	    depth: 2,
	    tags: [{
	        aspirations: true
	    }]
	}, {
	    id: '68707c85-2b58-43bf-9c1f-93c51b6dedf0',
	    img: "https://elearningindustry.com/wp-content/uploads/2014/08/9-Tips-To-Apply-Adult-Learning-Theory-to-eLearning.jpg",
	    question: "Regardless of your actual age, do you consider yourself to be an adult?",
	    color: "white",
	    depth: 2,
	    tags: [{
	        personality: true
	    }]
	}, {
	    id: 'bd360003-5098-49e3-a114-e4bce3cf9e7a',
	    img: "http://www.prevention.com/sites/prevention.com/files/static/anger-throwing-cup-628x363compass3085296.JPG?1405995496",
	    question: "What makes you angry?",
	    color: "white",
	    depth: 2,
	    tags: [{
	        personality: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: 'b2a77095-d9b1-4bec-aa16-37f99b06dc57',
	    img: "http://halfmeasuresroom.com/wp-content/uploads/2016/11/angry.jpg",
	    question: "When was the last time you were angry, and why?",
	    color: "white",
	    depth: 2,
	    tags: [{
	        personality: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: '88e77b97-df31-4b11-9fcc-12ce0afe14ad',
	    img: "https://s-media-cache-ak0.pinimg.com/564x/d3/43/b9/d343b907fd6cf7b7026fb0087f8cb3f3.jpg",
	    question: "What is a problem you used to have that you have solved for good?",
	    color: "white",
	    depth: 2,
	    tags: [{
	        personality: true
	    }, {
	        aspirations: true
	    }]
	}, {
	    id: '32287af2-6f21-4079-bff4-488ee39b5295',
	    img: "http://www.dingtwist.com/wp-content/uploads/2014/07/giving-advice.jpg",
	    question: "If you could give an insight to your 20-year-old self, what would it be?",
	    color: "white",
	    depth: 2,
	    tags: [{
	        aspirations: true
	    }, {
	        history: true
	    }]
	}, {
	    id: '8938a022-2284-41ea-9ec8-10975e7bcf2b',
	    img: "https://cdn.psychologytoday.com/sites/default/files/styles/image-article_inline_full/public/blogs/130326/2013/10/134511-134329.jpg?itok=EjrVL-zP",
	    question: "What's something you resisted doing that you ended up liking?",
	    color: "white",
	    depth: 2,
	    tags: [{
	        preferences: true
	    }, {
	        personality: true
	    }]
	}, {
	    id: '139d7c2a-f647-4794-8d02-620f72deed42',
	    img: "http://farm1.static.flickr.com/75/156398965_7204fbb1ba_b.jpg",
	    question: "What's the single worst quality a person can have?",
	    color: "white",
	    depth: 2,
	    tags: [{
	        personality: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: '6fb916b5-cc8c-4025-9fde-1bae1ff5540d',
	    img: "http://www.space.com/images/i/000/055/491/original/Mike_killian-milky-way.jpg?interpolation=lanczos-none&fit=inside%7C660:*",
	    question: "What will you never know for sure?",
	    depth: 2,
	    tags: []
	}, {
	    id: '94c95cec-1344-4615-8cc7-27bf88bce8ad',
	    img: "http://www.radioiloveit.com/wp-content/uploads/female-radio-listener-headphones-smiling-eyes-closed-01.jpg",
	    question: "What song reminds you of good times from your teenage years?",
	    depth: 2,
	    tags: [{
	        memory: true
	    }]
	}, {
	    id: 'd9d155a8-0b9d-47ff-b9a4-f0db8337ff0e',
	    img: "https://drscdn.500px.org/photo/80448871/m%3D900/53a4c1fb9f6494b856f0f1956e691bed",
	    question: "What's something you don't care about even though lots of people do seem to care about it?",
	    depth: 2,
	    tags: [{
	        personality: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: 'cb628e5a-b41f-4747-89cc-bcedce36d98a',
	    img: "http://www.safran-arts.com/art/photographs-new-york-crowded-street-48-53-12.jpg",
	    question: "When did you last judge someone you didn't even know?",
	    depth: 2,
	    tags: [{
	        personality: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: '4a686760-7f7b-4d0e-8b40-e7317683eebf',
	    img: "https://media.licdn.com/mpr/mpr/AAEAAQAAAAAAAAW3AAAAJGRhM2YyM2FhLTE1YjMtNDU5ZS04MjNhLTM2ZGU1NWQ2NmU0NA.jpg",
	    question: "In one word, what's standing between you and your biggest goal?",
	    depth: 2,
	    tags: [{
	        personality: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: 'a91acf52-1969-46ca-bbd5-a161c5c5549d',
	    img: "http://unitedbloggers.no/uploads/sites/88/2015/12/secret1.jpg",
	    question: "Do you have a secret hunch about how you will die?",
	    depth: 2,
	    tags: [{
	        negative: true
	    }]
	}, {
	    id: '5222b604-ed45-4616-be6d-4acf8b6979eb',
	    img: "http://www.abc.net.au/news/image/6813488-3x2-940x627.jpg",
	    question: "Name three things you and someone else playing this game appear to have in common.",
	    depth: 2,
	    tags: []
	}, {
	    id: 'f4ed7b35-f048-4f8c-9633-a6f504a03ae9',
	    img: "http://az616578.vo.msecnd.net/files/2016/02/14/635910651833815068-341846207_swing-childhood-mood.jpg",
	    question: "If you could change anything about the way you were raised, what would it be?",
	    depth: 2,
	    tags: [{
	        family: true
	    }, {
	        memory: true
	    }]
	}, {
	    id: '02848fb8-1944-4973-8d7a-5c248b59b02c',
	    img: "https://s-media-cache-ak0.pinimg.com/originals/1f/97/9d/1f979db6e76458eed51f1464cd1f9db5.jpg",
	    question: "If a crystal ball could tell you the truth about yourself, your life, or anything else, what would you want to know?",
	    depth: 2,
	    tags: []
	}, {
	    id: '6eb48c72-aeef-4c3a-87b0-c64e8ac95a63',
	    img: "http://www.billmarshjr.com/wp-content/uploads/2015/08/dream1.jpg",
	    question: "Is there something that you’ve dreamed of doing for a long time? Why haven’t you done it?",
	    depth: 2,
	    tags: [{
	        personality: true
	    }, {
	        negative: true
	    }]
	}, {
	    id: '62a8402b-720b-4ff5-b02e-25105b07227d',
	    img: "http://kingofwallpapers.com/sprout/sprout-023.jpg",
	    question: "What is the greatest accomplishment of your life?",
	    depth: 2,
	    tags: [{
	        history: true
	    }]
	}, {
	    id: '4656d0bd-5e96-4234-8573-13a162a88cea',
	    img: "https://cdn.thinglink.me/api/image/773479278535770114/1240/10/scaletowidth",
	    question: "What do you value most in a friendship?",
	    depth: 2,
	    tags: [{
	        personality: true
	    }]
	}, {
	    id: '16573d3f-1a39-40a8-9484-ee6e527947cf',
	    img: "http://www.hbc333.com/data/out/85/47131972-friendship-pictures.png",
	    question: "What does friendship mean to you?",
	    depth: 2,
	    tags: [{
	        personality: true
	    }]
	}, {
	    id: 'eaa21afb-ef95-453a-ab65-0a32eb2b2eee',
	    img: "http://www.pen-outwrite.org/wp-content/uploads/2015/05/Image-Eric-Kilby-Embrace-Sculpture1-700x467.jpg",
	    question: "What roles do love and affection play in your life?",
	    depth: 2,
	    tags: [{
	        personality: true
	    }]
	}, {
	    id: 'cba96c61-e291-4cde-a6a1-ccd266b45414',
	    img: "https://www.callcentrehelper.com/images/stories/2010/2015/08/positive.jpg",
	    question: "Alternate sharing something you consider a positive characteristic of the the people in your group. Share a total of two items with each person.",
	    depth: 2,
	    tags: []
	}, {
	    id: '5aab71ba-0a39-4eb2-bb46-54568f721202',
	    img: "http://www.clipartkid.com/images/786/children-silhouettes-holding-hands-up-by-macinivnw-on-deviantart-LmjNJU-clipart.jpg",
	    question: "Make three true 'we' statements each. For instance, 'We are all in this room feeling ...' ",
	    depth: 2,
	    tags: []
	}, {
	    id: 'ce2dc065-748e-412b-9e54-b3a286013099',
	    img: 'http://files.differencebetween.com/wp-content/uploads/2016/03/Difference_Between_CloseFriend_BestFriend_Image1.jpg',
	    question: "If you were going to become a close friend with the person to your right, please share what would be important for him or her to know.",
	    depth: 2,
	    tags: []
	}, {
	    id: '216fb7c3-7aa9-4dbe-90e2-7a303537c0e3',
	    img: 'http://wmsmile.com/wp-content/uploads/2015/12/smiling-group-of-people.jpg',
	    question: "Tell the person to your right something that you like about them already.",
	    depth: 2,
	    tags: []
	}, {
	    id: '4288d5d9-bef3-4fef-a854-089612862ae9',
	    img: 'https://s-media-cache-ak0.pinimg.com/originals/64/d4/e7/64d4e7f648c93f7c98203034a5d79923.jpg',
	    question: "What, if anything, is too serious to be joked about?",
	    depth: 2,
	    tags: [{
	        personality: true
	    }]
	}, {
	    id: '5bd98256-9bc6-4c5f-a5bd-60862c646c42',
	    img: 'http://static.wixstatic.com/media/875d61_a96bf8a3f9384749b9a3830ba35ac918.jpg',
	    question: "Your house, containing everything you own, catches fire. After saving your loved ones and pets, you have time to safely make a final dash to save any one item. What would it be? Why?",
	    depth: 2,
	    tags: [{
	        preferences: true
	    }]
	}];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = data2;

/***/ },

/***/ 263:
/***/ function(module, exports) {

	"use strict";
	
	var data3 = [{
	    id: 'd4521bfd-c63d-41d2-bbe2-a5ed564ae4e7',
	    img: 'http://data.websitebox.com/data/users/0015/580/uploads/VXQ_fireplacejpg.jpg',
	    question: 'How close and warm is your family? Do you feel your childhood was happier than most other people\'s?',
	    depth: 3,
	    tags: [{ family: true }, { childhood: true }, { memory: true }]
	}, {
	    id: '2e9f3012-297a-42f3-bd31-1e5ad60f3fca',
	    img: 'http://www.smallbusinessconnect.org/wp-content/uploads/2016/05/mother-429158_1920.jpg',
	    question: 'How do you feel about your relationship with your mother?',
	    depth: 3,
	    tags: [{ family: true }]
	}, {
	    id: '23ada855-ae90-455f-a901-959c29f17a04',
	    img: "https://static.pexels.com/photos/6371/red-love-heart-valentines.jpg",
	    question: "List the people you've dated in life.  Say a few words about each relationship.",
	    color: "white",
	    depth: 3,
	    tags: [{ lovelife: true }, { history: true }]
	}, {
	    id: 'b186dc2b-6f03-4fc7-bcb0-ecbf58d8fad3',
	    img: "https://media.giphy.com/media/nm82hi108J4DC/giphy-facebook_s.jpg",
	    question: "How often do you do things out of spite?",
	    color: "white",
	    depth: 3,
	    tags: [{ personality: true }, { negative: true }]
	}, {
	    id: '1836cad2-c72f-4497-99df-78af54f198b5',
	    img: "https://s-media-cache-ak0.pinimg.com/736x/ae/c1/9f/aec19f14b08aeab81758183ffbd238c5.jpg",
	    question: "How do you think your future self will judge the person you are today?",
	    color: "white",
	    depth: 3,
	    tags: [{ aspirations: true }]
	}, {
	    id: 'd8349ef7-0d37-4085-abdb-16548b3dc7fb',
	    img: "https://theconsciousprocess.files.wordpress.com/2013/01/enjoy_the_silence.jpg",
	    question: "What do you most regret never telling someone?",
	    depth: 3,
	    tags: [{ negative: true }, { memory: true }]
	}, {
	    id: '1cfeb6c0-6838-42e9-b4f1-14a0d811ce8b',
	    img: "http://www.headoverheels.org/wp/wp-content/uploads/2007/02/stan-on-bench.jpg",
	    question: "Who in your life do you wish you had met sooner?",
	    depth: 3,
	    tags: [{ personality: true }]
	}, {
	    id: 'de3aa25e-2096-487b-82aa-06467d4e1543',
	    img: "http://i.huffpost.com/gen/1754564/thumbs/o-LOVE-570.jpg?6",
	    question: "Tell the story of your first love.  How did it start?  How did it end?",
	    depth: 3,
	    tags: [{ lovelife: true }, { memory: true }]
	}, {
	    id: 'f76ad266-0bbe-4dea-8a04-c9ef5efba59e',
	    img: "http://eskipaper.com/images/field-13.jpg",
	    question: "If you knew that in one year you would die suddenly, would you change anything about the way you are now living? Why?",
	    depth: 3,
	    tags: [{ aspirations: true }, { negative: true }]
	}, {
	    id: '2451c83d-88e6-45ad-9c2f-648853758d06',
	    img: "http://data.websitebox.com/data/users/0015/580/uploads/VXQ_fireplacejpg.jpg",
	    question: "How close and warm is your family? Do you feel your childhood was happier than most other people's?",
	    depth: 3,
	    tags: [{ family: true }, { memory: true }]
	}, {
	    id: '3a1cf290-681a-454f-8858-475f4943d7a1',
	    img: "http://www.smallbusinessconnect.org/wp-content/uploads/2016/05/mother-429158_1920.jpg",
	    question: "How do you feel about your relationship with your mother?",
	    depth: 3,
	    tags: [{ family: true }]
	}, {
	    id: '2d8790dc-e868-4d7d-ac2b-1c881509e17b',
	    img: 'http://userfiles.steadyhealth.com/userfiles/articles/couple-sunset-talk.jpg',
	    question: "Complete this sentence: 'I wish I had someone with whom I could share ... '",
	    depth: 3,
	    tags: [{ interests: true }]
	}, {
	    id: '1e24c99c-d001-4d4d-91ae-804afd3e6f96',
	    img: 'https://image.freepik.com/free-photo/top-view-of-friends-having-fun_1098-980.jpg',
	    question: "Tell the person to your right what you like about them; be very honest this time, saying things that you might not say to someone you've just met.",
	    depth: 3,
	    tags: []
	}, {
	    id: '12dbc6f3-cb02-4ddc-ac5d-5c94d73b693f',
	    img: 'https://starpointcounselingcenter.files.wordpress.com/2014/10/1372206815_friend-venting-consoling-11070802.jpg',
	    question: "When did you last cry in front of another person? By yourself?",
	    depth: 3,
	    tags: [{ negative: true }]
	}, {
	    id: '8ab90458-1d84-4248-b11d-7e9fe82f50b3',
	    img: 'https://mdhistoricaltrust.files.wordpress.com/2015/02/1-img_7639crop.jpg',
	    question: "If you were to die this evening with no opportunity to communicate with anyone, what would you most regret not having told someone? Why haven’t you told them yet?",
	    depth: 3,
	    tags: [{ negative: true }]
	}, {
	    id: '5c2e14bc-6e29-45ae-a71e-9d9c23808b4a',
	    img: 'http://photos.jibble.org/Places/The%20Netherlands/Arnhem%20Oosterbeek%20War%20Cemetary/P1000434%20Gravestones.JPG',
	    question: "Of all the people in your family, whose death would you find most disturbing? Why?",
	    depth: 3,
	    tags: [{ negative: true }]
	}, {
	    id: 'f214c714-049d-4e8c-b697-b966a1228230',
	    img: 'http://ell.h-cdn.co/assets/cm/14/52/980x490/549b4f6c36de7_-_elle-code-red-h.jpg',
	    question: "Share a personal problem and ask the person to your right’s advice on how he or she might handle it. Also, ask your partner to reflect back to you how you seem to be feeling about the problem you have chosen.",
	    depth: 3,
	    tags: []
	}];
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = data3;

/***/ },

/***/ 264:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(9);
	
	var DepthButton = function (_React$Component) {
	    _inherits(DepthButton, _React$Component);
	
	    function DepthButton(props) {
	        _classCallCheck(this, DepthButton);
	
	        return _possibleConstructorReturn(this, (DepthButton.__proto__ || Object.getPrototypeOf(DepthButton)).call(this, props));
	    }
	
	    _createClass(DepthButton, [{
	        key: 'chooseColor',
	        value: function chooseColor() {
	            if (this.props.depth === 1) {
	                return ['#2ECC71', '#208e4e'];
	            } else if (this.props.depth === 2) {
	                return ['#3498db', '#1d6fa5'];
	            } else if (this.props.depth === 3) {
	                return ['#8067B7', '#4C3D6D'];
	            } else {
	                return ['#FFFFFF', '#FFFFFF'];
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return React.createElement("button", { style: {
	                    border: 'none',
	                    textAlign: 'center',
	                    padding: '1.2vw 3vw 1vw',
	                    borderRadius: '0.2vw',
	                    fontWeight: 'bold',
	                    textTransform: 'uppercase',
	                    margin: '1.3vw',
	                    outline: 'none',
	                    cursor: 'pointer',
	                    transition: 'all .15s',
	                    color: 'white',
	                    background: this.chooseColor()[0],
	                    boxShadow: '0px 0.4vw 0px ' + this.chooseColor()[1]
	                }, onClick: function onClick() {
	                    _this2.props.depthSelectionCallback(_this2.props.depth);
	                } }, "Level " + this.props.depth);
	        }
	    }]);
	
	    return DepthButton;
	}(React.Component);
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = DepthButton;

/***/ },

/***/ 265:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(9);
	
	var QuestionAndImage = function (_React$Component) {
	    _inherits(QuestionAndImage, _React$Component);
	
	    function QuestionAndImage(props) {
	        _classCallCheck(this, QuestionAndImage);
	
	        return _possibleConstructorReturn(this, (QuestionAndImage.__proto__ || Object.getPrototypeOf(QuestionAndImage)).call(this, props));
	    }
	
	    _createClass(QuestionAndImage, [{
	        key: "render",
	        value: function render() {
	            return React.createElement("div", null, React.createElement("span", { style: {
	                    position: "absolute",
	                    padding: 10,
	                    margin: 10,
	                    backgroundColor: 'rgba(0,0,0,0.5)',
	                    color: this.props.thing.color || 'white',
	                    fontFamily: 'courier',
	                    fontSize: '1.5em'
	                } }, this.props.thing.question), React.createElement("img", { src: this.props.thing.img, style: {
	                    width: '100%',
	                    margin: 'auto'
	                } }));
	        }
	    }]);
	
	    return QuestionAndImage;
	}(React.Component);
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = QuestionAndImage;

/***/ },

/***/ 266:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(9);
	var depth_button_1 = __webpack_require__(264);
	var question_and_image_1 = __webpack_require__(265);
	
	var QuestionViewer = function (_React$Component) {
	    _inherits(QuestionViewer, _React$Component);
	
	    function QuestionViewer(props) {
	        _classCallCheck(this, QuestionViewer);
	
	        var _this = _possibleConstructorReturn(this, (QuestionViewer.__proto__ || Object.getPrototypeOf(QuestionViewer)).call(this, props));
	
	        _this.state = {};
	        _this.state.current = 0;
	        _this.state.depth = 1;
	        _this.state.used = [_this.getData()[_this.state.current].id];
	        return _this;
	    }
	
	    _createClass(QuestionViewer, [{
	        key: 'getData',
	
	        // Return all questions in the data set where the intimacy depth is the same as what's currently saved in state 
	        value: function getData() {
	            if (this.state.depth === 1) {
	                return this.props.level1;
	            } else if (this.state.depth === 2) {
	                return this.props.level2;
	            } else if (this.state.depth === 3) {
	                return this.props.level3;
	            }
	        }
	    }, {
	        key: 'depthSelection',
	        value: function depthSelection(depth) {
	            this.setState({
	                depth: depth,
	                current: 0
	            });
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            var choosing = false;
	            var counter = 0;
	            //Choose a random index
	            //and arbitrary counter is less than 500 (CAN'T HAVE MORE THAN 500 QUESTIONS???) 
	            while (choosing == false && counter < 500) {
	                var new_question_index = Math.floor(Math.random() * this.getData().length);
	                //If the id of the question in the data at that index doesn't exist in used...
	                if (!(this.state.used.indexOf(this.getData()[new_question_index].id) >= 0)) {
	                    choosing = true;
	                }
	                counter++;
	            }
	            if (choosing == true) {
	                //and set the state for current and update the used array
	                this.setState({
	                    current: new_question_index,
	                    used: this.state.used.concat(this.getData()[new_question_index].id)
	                });
	            }
	            console.log("These have been used:" + this.state.used);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement("div", null, React.createElement("div", { onClick: this.next.bind(this) }, React.createElement(question_and_image_1.default, { thing: this.getData()[this.state.current] })), React.createElement("div", { style: { textAlign: 'center' } }, React.createElement(depth_button_1.default, { depth: 1, depthSelectionCallback: this.depthSelection.bind(this) }), React.createElement(depth_button_1.default, { depth: 2, depthSelectionCallback: this.depthSelection.bind(this) }), React.createElement(depth_button_1.default, { depth: 3, depthSelectionCallback: this.depthSelection.bind(this) })));
	        }
	    }]);
	
	    return QuestionViewer;
	}(React.Component);
	
	;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = QuestionViewer;

/***/ },

/***/ 267:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(9);
	var question_viewer_1 = __webpack_require__(266);
	var level1_1 = __webpack_require__(261);
	var level2_1 = __webpack_require__(262);
	var level3_1 = __webpack_require__(263);
	// tags:
	//   abilities
	//   aspirations
	//   family
	//   finance
	//   history
	//   interests
	//   lovelife
	//   memory
	//   personality
	//   politics
	//   preferences
	
	var App = function (_React$Component) {
	    _inherits(App, _React$Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	    }
	
	    _createClass(App, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement("div", { style: { width: "100%" } }, React.createElement(question_viewer_1.default, { level1: level1_1.default, level2: level2_1.default, level3: level3_1.default }));
	        }
	    }]);
	
	    return App;
	}(React.Component);
	
	;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = App;

/***/ },

/***/ 268:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(277);
	__webpack_require__(638);
	var React = __webpack_require__(9);
	var ReactDOM = __webpack_require__(484);
	
	var _require = __webpack_require__(220),
	    Provider = _require.Provider;
	
	var _require2 = __webpack_require__(157),
	    Router = _require2.Router,
	    browserHistory = _require2.browserHistory;
	
	var _require3 = __webpack_require__(153),
	    syncHistoryWithStore = _require3.syncHistoryWithStore;
	
	var routes_1 = __webpack_require__(274);
	var configure_store_1 = __webpack_require__(272);
	__webpack_require__(634);
	var store = configure_store_1.default({});
	var history = syncHistoryWithStore(browserHistory, store);
	if (true) {
	    ReactDOM.render(React.createElement("div", null, React.createElement(Provider, { store: store }, React.createElement(Router, { history: history }, routes_1.default))), document.getElementById('root'));
	}

/***/ },

/***/ 269:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var is_promise_1 = __webpack_require__(276);
	var objectAssign = __webpack_require__(11);
	function promiseMiddleware(_ref) {
	    var dispatch = _ref.dispatch;
	
	    return function (next) {
	        return function (action) {
	            if (!is_promise_1.default(action.payload)) {
	                return next(action);
	            }
	            var types = action.types,
	                payload = action.payload,
	                meta = action.meta;
	            var promise = payload.promise,
	                data = payload.data;
	
	            var _types = _slicedToArray(types, 3),
	                PENDING = _types[0],
	                FULFILLED = _types[1],
	                REJECTED = _types[2];
	            /**
	             * Dispatch the pending action
	             */
	
	
	            dispatch(objectAssign({}, { type: PENDING }, data ? { payload: data } : {}, meta ? { meta: meta } : {}));
	            /**
	             * If successful, dispatch the fulfilled action, otherwise dispatch
	             * rejected action.
	             */
	            return promise.then(function (result) {
	                dispatch({
	                    type: FULFILLED,
	                    payload: result,
	                    meta: meta
	                });
	            }, function (error) {
	                dispatch({
	                    type: REJECTED,
	                    payload: error,
	                    meta: meta
	                });
	            });
	        };
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = promiseMiddleware;

/***/ },

/***/ 270:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var constants_1 = __webpack_require__(166);
	var immutable_1 = __webpack_require__(93);
	var INITIAL_STATE = immutable_1.fromJS({
	    count: 0
	});
	function counterReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: '' };
	
	    switch (action.type) {
	        case constants_1.INCREMENT_COUNTER:
	            return state.update('count', function (value) {
	                return value + 1;
	            });
	        case constants_1.DECREMENT_COUNTER:
	            return state.update('count', function (value) {
	                return value - 1;
	            });
	        case constants_1.LOGOUT_USER:
	            return state.merge(INITIAL_STATE);
	        default:
	            return state;
	    }
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = counterReducer;

/***/ },

/***/ 271:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var constants_1 = __webpack_require__(166);
	var immutable_1 = __webpack_require__(93);
	var INITIAL_STATE = immutable_1.fromJS({
	    token: null,
	    user: {},
	    hasError: false,
	    isLoading: false
	});
	function sessionReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: '', payload: null };
	
	    switch (action.type) {
	        case constants_1.LOGIN_USER_PENDING:
	            return state.merge(immutable_1.fromJS({
	                token: null,
	                user: {},
	                hasError: false,
	                isLoading: true
	            }));
	        case constants_1.LOGIN_USER_SUCCESS:
	            return state.merge(immutable_1.fromJS({
	                token: action.payload.token,
	                user: action.payload.profile,
	                hasError: false,
	                isLoading: false
	            }));
	        case constants_1.LOGIN_USER_ERROR:
	            return state.merge(immutable_1.fromJS({
	                hasError: true,
	                isLoading: false
	            }));
	        case constants_1.LOGOUT_USER:
	            return state.merge(INITIAL_STATE);
	        default:
	            return state;
	    }
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = sessionReducer;

/***/ },

/***/ 272:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var redux_1 = __webpack_require__(104);
	var immutable_1 = __webpack_require__(93);
	var react_router_1 = __webpack_require__(157);
	var react_router_redux_1 = __webpack_require__(153);
	var redux_thunk_1 = __webpack_require__(627);
	var persistState = __webpack_require__(620);
	var promise_middleware_1 = __webpack_require__(269);
	var logger_1 = __webpack_require__(273);
	var reducers_1 = __webpack_require__(167);
	function configureStore(initialState) {
	    var store = redux_1.createStore(reducers_1.default, initialState, redux_1.compose(redux_1.applyMiddleware.apply(redux_1, _toConsumableArray(_getMiddleware())), persistState('session', _getStorageConfig()),  false ? environment.devToolsExtension() : function (f) {
	        return f;
	    }));
	    _enableHotLoader(store);
	    return store;
	}
	function _getMiddleware() {
	    var middleware = [react_router_redux_1.routerMiddleware(react_router_1.browserHistory), promise_middleware_1.default, redux_thunk_1.default];
	    if (false) {
	        middleware = [].concat(_toConsumableArray(middleware), [logger_1.default]);
	    }
	    return middleware;
	}
	var environment = window || undefined;
	function _enableHotLoader(store) {
	    if (true) {
	        return;
	    }
	    var _module = module,
	        hot = _module.hot;
	
	    if (hot) {
	        hot.accept('../reducers', function () {
	            var nextRootReducer = __webpack_require__(167);
	            store.replaceReducer(nextRootReducer);
	        });
	    }
	}
	function _getStorageConfig() {
	    return {
	        key: 'typescript-react-redux-seed',
	        serialize: function serialize(store) {
	            return store && store.session ? JSON.stringify(store.session.toJS()) : store;
	        },
	        deserialize: function deserialize(state) {
	            return {
	                session: state ? immutable_1.fromJS(JSON.parse(state)) : immutable_1.fromJS({})
	            };
	        }
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = configureStore;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(260)(module)))

/***/ },

/***/ 273:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var createLogger = __webpack_require__(626);
	var immutable_to_js_1 = __webpack_require__(275);
	var logger = createLogger({
	    collapsed: true,
	    stateTransformer: function stateTransformer(state) {
	        return immutable_to_js_1.default(state);
	    },
	    predicate: function predicate(getState, _ref) {
	        var type = _ref.type;
	
	        return type !== 'redux-form/BLUR' && type !== 'redux-form/CHANGE' && type !== 'redux-form/FOCUS' && type !== 'redux-form/TOUCH';
	    }
	});
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = logger;

/***/ },

/***/ 274:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(9);
	
	var _require = __webpack_require__(157),
	    IndexRoute = _require.IndexRoute,
	    Route = _require.Route;
	
	var app_1 = __webpack_require__(267);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = [React.createElement(Route, { path: "/", component: app_1.default }, " "), React.createElement(Route, { path: "/QuestionGame/", component: app_1.default }, " ")];

/***/ },

/***/ 275:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var immutable_1 = __webpack_require__(93);
	/**
	 * [immutableToJS
	 *    converts properties of the provided [state] object from immutable
	 *    data structures to regular JavaScript data structures - used with
	 *    redux-logger
	 *
	 * @param  {object} state [state reference]
	 * @return {object}       [transformed state]
	 */
	function immutableToJS(state) {
	    return Object.keys(state).reduce(function (newState, key) {
	        var val = state[key];
	        newState[key] = immutable_1.Iterable.isIterable(val) ? val.toJS() : val;
	        return newState;
	    }, {});
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = immutableToJS;

/***/ },

/***/ 276:
/***/ function(module, exports) {

	"use strict";
	/**
	 * Returns whether the provided value is a promise
	 *
	 * @param {object} value Potential promise
	 * @return {Boolean}
	 */
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function isPromise(value) {
	    if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	        return value.promise && typeof value.promise.then === 'function';
	    }
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = isPromise;

/***/ },

/***/ 459:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(460)();
	// imports
	
	
	// module
	exports.push([module.id, "*{box-sizing:border-box}body{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Helvetica,sans-serif;line-height:1.5;margin:0;color:#111;background-color:#fff}img{max-width:100%;height:auto}svg{max-height:100%}a{color:#07c}h1,h2,h3,h4,h5,h6{font-weight:600;line-height:1.25;margin-top:1em;margin-bottom:.5em}h1{font-size:32px;font-size:2rem}h2{font-size:24px;font-size:1.5rem}h3{font-size:20px;font-size:1.25rem}h4{font-size:16px;font-size:1rem}h5{font-size:14px;font-size:.875rem}h6{font-size:12px;font-size:.75rem}blockquote,dl,ol,p,pre,ul{margin-top:1em;margin-bottom:1em}code,pre,samp{font-family:Roboto Mono,Source Code Pro,Menlo,Consolas,Liberation Mono,monospace}code,samp{padding:.125em}code,pre,samp{font-size:87.5%}pre{overflow:scroll}blockquote{font-size:20px;font-size:1.25rem;font-style:italic;margin-left:0}hr{margin-top:1.5em;margin-bottom:1.5em;border:0;border-bottom-width:1px;border-bottom-style:solid;border-bottom-color:#ccc}.btn{font-family:inherit;font-size:inherit;font-weight:700;cursor:pointer;display:inline-block;line-height:18px;line-height:1.125rem;padding:8px 16px;padding:.5rem 1rem;margin:0;height:auto;border:1px solid transparent;vertical-align:middle;-webkit-appearance:none;color:inherit;background-color:transparent}.btn,.btn:hover{text-decoration:none}.btn:focus{outline:none;border-color:rgba(0,0,0,.125);box-shadow:0 0 0 3px rgba(0,0,0,.25)}::-moz-focus-inner{border:0;padding:0}.btn-primary{color:#fff;background-color:#0074d9;border-radius:3px}.btn-primary:hover{box-shadow:inset 0 0 0 20rem rgba(0,0,0,.0625)}.btn-primary:active{box-shadow:inset 0 0 0 20rem rgba(0,0,0,.125),inset 0 3px 4px 0 rgba(0,0,0,.25),0 0 1px rgba(0,0,0,.125)}.btn-primary.is-disabled,.btn-primary:disabled{opacity:.5}.bg-black{background-color:#111}.bg-gray{background-color:#aaa}.bg-silver{background-color:#ddd}.bg-white{background-color:#fff}.bg-aqua{background-color:#7fdbff}.bg-blue{background-color:#0074d9}.bg-navy{background-color:#001f3f}.bg-teal{background-color:#39cccc}.bg-green{background-color:#2ecc40}.bg-olive{background-color:#3d9970}.bg-lime{background-color:#01ff70}.bg-yellow{background-color:#ffdc00}.bg-orange{background-color:#ff851b}.bg-red{background-color:#ff4136}.bg-fuchsia{background-color:#f012be}.bg-purple{background-color:#b10dc9}.bg-maroon{background-color:#85144b}.black{color:#111}.gray{color:#aaa}.silver{color:#ddd}.white{color:#fff}.aqua{color:#7fdbff}.blue{color:#0074d9}.navy{color:#001f3f}.teal{color:#39cccc}.green{color:#2ecc40}.olive{color:#3d9970}.lime{color:#01ff70}.yellow{color:#ffdc00}.orange{color:#ff851b}.red{color:#ff4136}.fuchsia{color:#f012be}.purple{color:#b10dc9}.maroon{color:#85144b}.color-inherit{color:inherit}.muted{opacity:.5}.label{font-size:14px;font-size:.875rem;font-weight:700;display:block;margin-bottom:8px;margin-bottom:.5rem}.input,.select{height:40px;height:2.5rem}.input,.select,.textarea{font-family:inherit;font-size:inherit;display:block;width:100%;padding:8px;padding:.5rem;margin-bottom:16px;margin-bottom:1rem;border:1px solid #ccc;border-radius:3px;box-sizing:border-box}.input-range{vertical-align:middle;padding-top:8px;padding-top:.5rem;padding-bottom:8px;padding-bottom:.5rem;color:inherit;background-color:transparent;-webkit-appearance:none}.input-range::-webkit-slider-thumb{position:relative;width:8px;width:.5rem;height:20px;height:1.25rem;cursor:pointer;margin-top:-8px;margin-top:-.5rem;border-radius:3px;background-color:currentcolor;-webkit-appearance:none}.input-range::-webkit-slider-thumb:before{content:\"\";display:block;position:absolute;top:-8px;top:-.5rem;left:-14px;left:-.875rem;width:36px;width:2.25rem;height:36px;height:2.25rem;opacity:0}.input-range::-moz-range-thumb{width:8px;width:.5rem;height:20px;height:1.25rem;cursor:pointer;border-radius:3px;border-color:transparent;border-width:0;background-color:currentcolor}.input-range::-webkit-slider-runnable-track{height:4px;height:.25rem;cursor:pointer;border-radius:3px;background-color:rgba(0,0,0,.25)}.input-range::-moz-range-track{height:4px;height:.25rem;cursor:pointer;border-radius:3px;background-color:rgba(0,0,0,.25)}.input-range:focus{outline:none}@media (min-width:40em){.sm-m0{margin:0}.sm-mt0{margin-top:0}.sm-mr0{margin-right:0}.sm-mb0{margin-bottom:0}.sm-ml0,.sm-mx0{margin-left:0}.sm-mx0{margin-right:0}.sm-my0{margin-top:0;margin-bottom:0}.sm-m1{margin:.5rem}.sm-mt1{margin-top:.5rem}.sm-mr1{margin-right:.5rem}.sm-mb1{margin-bottom:.5rem}.sm-ml1,.sm-mx1{margin-left:.5rem}.sm-mx1{margin-right:.5rem}.sm-my1{margin-top:.5rem;margin-bottom:.5rem}.sm-m2{margin:1rem}.sm-mt2{margin-top:1rem}.sm-mr2{margin-right:1rem}.sm-mb2{margin-bottom:1rem}.sm-ml2,.sm-mx2{margin-left:1rem}.sm-mx2{margin-right:1rem}.sm-my2{margin-top:1rem;margin-bottom:1rem}.sm-m3{margin:2rem}.sm-mt3{margin-top:2rem}.sm-mr3{margin-right:2rem}.sm-mb3{margin-bottom:2rem}.sm-ml3,.sm-mx3{margin-left:2rem}.sm-mx3{margin-right:2rem}.sm-my3{margin-top:2rem;margin-bottom:2rem}.sm-m4{margin:4rem}.sm-mt4{margin-top:4rem}.sm-mr4{margin-right:4rem}.sm-mb4{margin-bottom:4rem}.sm-ml4,.sm-mx4{margin-left:4rem}.sm-mx4{margin-right:4rem}.sm-my4{margin-top:4rem;margin-bottom:4rem}.sm-mxn1{margin-left:-.5rem;margin-right:-.5rem}.sm-mxn2{margin-left:-1rem;margin-right:-1rem}.sm-mxn3{margin-left:-2rem;margin-right:-2rem}.sm-mxn4{margin-left:-4rem;margin-right:-4rem}.sm-ml-auto{margin-left:auto}.sm-mr-auto,.sm-mx-auto{margin-right:auto}.sm-mx-auto{margin-left:auto}}@media (min-width:52em){.md-m0{margin:0}.md-mt0{margin-top:0}.md-mr0{margin-right:0}.md-mb0{margin-bottom:0}.md-ml0,.md-mx0{margin-left:0}.md-mx0{margin-right:0}.md-my0{margin-top:0;margin-bottom:0}.md-m1{margin:.5rem}.md-mt1{margin-top:.5rem}.md-mr1{margin-right:.5rem}.md-mb1{margin-bottom:.5rem}.md-ml1,.md-mx1{margin-left:.5rem}.md-mx1{margin-right:.5rem}.md-my1{margin-top:.5rem;margin-bottom:.5rem}.md-m2{margin:1rem}.md-mt2{margin-top:1rem}.md-mr2{margin-right:1rem}.md-mb2{margin-bottom:1rem}.md-ml2,.md-mx2{margin-left:1rem}.md-mx2{margin-right:1rem}.md-my2{margin-top:1rem;margin-bottom:1rem}.md-m3{margin:2rem}.md-mt3{margin-top:2rem}.md-mr3{margin-right:2rem}.md-mb3{margin-bottom:2rem}.md-ml3,.md-mx3{margin-left:2rem}.md-mx3{margin-right:2rem}.md-my3{margin-top:2rem;margin-bottom:2rem}.md-m4{margin:4rem}.md-mt4{margin-top:4rem}.md-mr4{margin-right:4rem}.md-mb4{margin-bottom:4rem}.md-ml4,.md-mx4{margin-left:4rem}.md-mx4{margin-right:4rem}.md-my4{margin-top:4rem;margin-bottom:4rem}.md-mxn1{margin-left:-.5rem;margin-right:-.5rem}.md-mxn2{margin-left:-1rem;margin-right:-1rem}.md-mxn3{margin-left:-2rem;margin-right:-2rem}.md-mxn4{margin-left:-4rem;margin-right:-4rem}.md-ml-auto{margin-left:auto}.md-mr-auto,.md-mx-auto{margin-right:auto}.md-mx-auto{margin-left:auto}}@media (min-width:64em){.lg-m0{margin:0}.lg-mt0{margin-top:0}.lg-mr0{margin-right:0}.lg-mb0{margin-bottom:0}.lg-ml0,.lg-mx0{margin-left:0}.lg-mx0{margin-right:0}.lg-my0{margin-top:0;margin-bottom:0}.lg-m1{margin:.5rem}.lg-mt1{margin-top:.5rem}.lg-mr1{margin-right:.5rem}.lg-mb1{margin-bottom:.5rem}.lg-ml1,.lg-mx1{margin-left:.5rem}.lg-mx1{margin-right:.5rem}.lg-my1{margin-top:.5rem;margin-bottom:.5rem}.lg-m2{margin:1rem}.lg-mt2{margin-top:1rem}.lg-mr2{margin-right:1rem}.lg-mb2{margin-bottom:1rem}.lg-ml2,.lg-mx2{margin-left:1rem}.lg-mx2{margin-right:1rem}.lg-my2{margin-top:1rem;margin-bottom:1rem}.lg-m3{margin:2rem}.lg-mt3{margin-top:2rem}.lg-mr3{margin-right:2rem}.lg-mb3{margin-bottom:2rem}.lg-ml3,.lg-mx3{margin-left:2rem}.lg-mx3{margin-right:2rem}.lg-my3{margin-top:2rem;margin-bottom:2rem}.lg-m4{margin:4rem}.lg-mt4{margin-top:4rem}.lg-mr4{margin-right:4rem}.lg-mb4{margin-bottom:4rem}.lg-ml4,.lg-mx4{margin-left:4rem}.lg-mx4{margin-right:4rem}.lg-my4{margin-top:4rem;margin-bottom:4rem}.lg-mxn1{margin-left:-.5rem;margin-right:-.5rem}.lg-mxn2{margin-left:-1rem;margin-right:-1rem}.lg-mxn3{margin-left:-2rem;margin-right:-2rem}.lg-mxn4{margin-left:-4rem;margin-right:-4rem}.lg-ml-auto{margin-left:auto}.lg-mr-auto,.lg-mx-auto{margin-right:auto}.lg-mx-auto{margin-left:auto}}@media (min-width:40em){.sm-p0{padding:0}.sm-pt0{padding-top:0}.sm-pr0{padding-right:0}.sm-pb0{padding-bottom:0}.sm-pl0,.sm-px0{padding-left:0}.sm-px0{padding-right:0}.sm-py0{padding-top:0;padding-bottom:0}.sm-p1{padding:.5rem}.sm-pt1{padding-top:.5rem}.sm-pr1{padding-right:.5rem}.sm-pb1{padding-bottom:.5rem}.sm-pl1,.sm-px1{padding-left:.5rem}.sm-px1{padding-right:.5rem}.sm-py1{padding-top:.5rem;padding-bottom:.5rem}.sm-p2{padding:1rem}.sm-pt2{padding-top:1rem}.sm-pr2{padding-right:1rem}.sm-pb2{padding-bottom:1rem}.sm-pl2,.sm-px2{padding-left:1rem}.sm-px2{padding-right:1rem}.sm-py2{padding-top:1rem;padding-bottom:1rem}.sm-p3{padding:2rem}.sm-pt3{padding-top:2rem}.sm-pr3{padding-right:2rem}.sm-pb3{padding-bottom:2rem}.sm-pl3,.sm-px3{padding-left:2rem}.sm-px3{padding-right:2rem}.sm-py3{padding-top:2rem;padding-bottom:2rem}.sm-p4{padding:4rem}.sm-pt4{padding-top:4rem}.sm-pr4{padding-right:4rem}.sm-pb4{padding-bottom:4rem}.sm-pl4,.sm-px4{padding-left:4rem}.sm-px4{padding-right:4rem}.sm-py4{padding-top:4rem;padding-bottom:4rem}}@media (min-width:52em){.md-p0{padding:0}.md-pt0{padding-top:0}.md-pr0{padding-right:0}.md-pb0{padding-bottom:0}.md-pl0,.md-px0{padding-left:0}.md-px0{padding-right:0}.md-py0{padding-top:0;padding-bottom:0}.md-p1{padding:.5rem}.md-pt1{padding-top:.5rem}.md-pr1{padding-right:.5rem}.md-pb1{padding-bottom:.5rem}.md-pl1,.md-px1{padding-left:.5rem}.md-px1{padding-right:.5rem}.md-py1{padding-top:.5rem;padding-bottom:.5rem}.md-p2{padding:1rem}.md-pt2{padding-top:1rem}.md-pr2{padding-right:1rem}.md-pb2{padding-bottom:1rem}.md-pl2,.md-px2{padding-left:1rem}.md-px2{padding-right:1rem}.md-py2{padding-top:1rem;padding-bottom:1rem}.md-p3{padding:2rem}.md-pt3{padding-top:2rem}.md-pr3{padding-right:2rem}.md-pb3{padding-bottom:2rem}.md-pl3,.md-px3{padding-left:2rem}.md-px3{padding-right:2rem}.md-py3{padding-top:2rem;padding-bottom:2rem}.md-p4{padding:4rem}.md-pt4{padding-top:4rem}.md-pr4{padding-right:4rem}.md-pb4{padding-bottom:4rem}.md-pl4,.md-px4{padding-left:4rem}.md-px4{padding-right:4rem}.md-py4{padding-top:4rem;padding-bottom:4rem}}@media (min-width:64em){.lg-p0{padding:0}.lg-pt0{padding-top:0}.lg-pr0{padding-right:0}.lg-pb0{padding-bottom:0}.lg-pl0,.lg-px0{padding-left:0}.lg-px0{padding-right:0}.lg-py0{padding-top:0;padding-bottom:0}.lg-p1{padding:.5rem}.lg-pt1{padding-top:.5rem}.lg-pr1{padding-right:.5rem}.lg-pb1{padding-bottom:.5rem}.lg-pl1,.lg-px1{padding-left:.5rem}.lg-px1{padding-right:.5rem}.lg-py1{padding-top:.5rem;padding-bottom:.5rem}.lg-p2{padding:1rem}.lg-pt2{padding-top:1rem}.lg-pr2{padding-right:1rem}.lg-pb2{padding-bottom:1rem}.lg-pl2,.lg-px2{padding-left:1rem}.lg-px2{padding-right:1rem}.lg-py2{padding-top:1rem;padding-bottom:1rem}.lg-p3{padding:2rem}.lg-pt3{padding-top:2rem}.lg-pr3{padding-right:2rem}.lg-pb3{padding-bottom:2rem}.lg-pl3,.lg-px3{padding-left:2rem}.lg-px3{padding-right:2rem}.lg-py3{padding-top:2rem;padding-bottom:2rem}.lg-p4{padding:4rem}.lg-pt4{padding-top:4rem}.lg-pr4{padding-right:4rem}.lg-pb4{padding-bottom:4rem}.lg-pl4,.lg-px4{padding-left:4rem}.lg-px4{padding-right:4rem}.lg-py4{padding-top:4rem;padding-bottom:4rem}}.lg-media,.md-media,.media,.sm-media{margin-left:-8px;margin-left:-.5rem;margin-right:-8px;margin-right:-.5rem}.media{display:-webkit-flex;display:-ms-flexbox;display:flex}.media-center{-webkit-align-items:center;-ms-flex-align:center;align-items:center}.media-bottom{-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end}.media-body,.media-img{padding-left:8px;padding-left:.5rem;padding-right:8px;padding-right:.5rem}.media-body{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}@media (min-width:40em){.sm-media{display:-webkit-flex;display:-ms-flexbox;display:flex}}@media (min-width:52em){.md-media{display:-webkit-flex;display:-ms-flexbox;display:flex}}@media (min-width:64em){.lg-media{display:-webkit-flex;display:-ms-flexbox;display:flex}}.all-initial{-webkit-animation:none 0s ease 0s 1 normal none running;animation:none 0s ease 0s 1 normal none running;-webkit-backface-visibility:visible;backface-visibility:visible;background:transparent none repeat 0 0/auto auto padding-box border-box scroll;border:medium none currentColor;border-collapse:separate;border-image:none;border-radius:0;border-spacing:0;bottom:auto;box-shadow:none;box-sizing:content-box;caption-side:top;clear:none;clip:auto;color:#000;-webkit-columns:auto;-moz-columns:auto;columns:auto;-webkit-column-count:auto;-moz-column-count:auto;column-count:auto;-webkit-column-fill:balance;-moz-column-fill:balance;column-fill:balance;-webkit-column-gap:normal;-moz-column-gap:normal;column-gap:normal;-webkit-column-rule:medium none currentColor;-moz-column-rule:medium none currentColor;column-rule:medium none currentColor;-webkit-column-span:1;-moz-column-span:1;column-span:1;-webkit-column-width:auto;-moz-column-width:auto;column-width:auto;content:normal;counter-increment:none;counter-reset:none;cursor:auto;direction:ltr;display:inline;empty-cells:show;float:none;font-family:serif;font-size:medium;font-style:normal;font-variant:normal;font-weight:400;font-stretch:normal;line-height:normal;height:auto;-webkit-hyphens:none;-ms-hyphens:none;hyphens:none;left:auto;letter-spacing:normal;list-style:disc outside none;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;opacity:1;orphans:2;outline:medium none invert;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;-webkit-perspective:none;perspective:none;-webkit-perspective-origin:50% 50%;perspective-origin:50% 50%;position:static;right:auto;-moz-tab-size:8;tab-size:8;table-layout:auto;text-align:left;text-align-last:auto;text-decoration:none;text-indent:0;text-shadow:none;text-transform:none;top:auto;-webkit-transform:none;-ms-transform:none;transform:none;-webkit-transform-origin:50% 50% 0;-ms-transform-origin:50% 50% 0;transform-origin:50% 50% 0;-webkit-transform-style:flat;transform-style:flat;transition:none 0s ease 0s;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:2;width:auto;word-spacing:normal;z-index:auto;all:initial}.all-unset{all:unset}.all-inherit{all:inherit}.all-revert{all:revert}.progress{display:block;width:100%;height:9px;height:.5625rem;margin:8px 0;margin:.5rem 0;overflow:hidden;background-color:rgba(0,0,0,.125);border:0;border-radius:10000px;-webkit-appearance:none}.progress::-webkit-progress-bar{-webkit-appearance:none;background-color:rgba(0,0,0,.125)}.progress::-webkit-progress-value{-webkit-appearance:none;background-color:currentcolor}.progress::-moz-progress-bar{background-color:currentcolor}.bg-lighten-1{background-color:hsla(0,0%,100%,.0625)}.bg-lighten-2{background-color:hsla(0,0%,100%,.125)}.bg-lighten-3{background-color:hsla(0,0%,100%,.25)}.bg-lighten-4{background-color:hsla(0,0%,100%,.5)}.bg-cover{background-size:cover}.bg-contain{background-size:contain}.bg-center{background-position:50%}.bg-top{background-position:top}.bg-right{background-position:100%}.bg-bottom{background-position:bottom}.bg-left{background-position:0}.bg-no-repeat{background-repeat:no-repeat}.bg-repeat-x{background-repeat:repeat-x}.bg-repeat-y{background-repeat:repeat-y}.bg-darken-1{background-color:rgba(0,0,0,.0625)}.bg-darken-2{background-color:rgba(0,0,0,.125)}.bg-darken-3{background-color:rgba(0,0,0,.25)}.bg-darken-4{background-color:rgba(0,0,0,.5)}.h1{font-size:32px;font-size:2rem}.h2{font-size:24px;font-size:1.5rem}.h3{font-size:20px;font-size:1.25rem}.h4{font-size:16px;font-size:1rem}.h5{font-size:14px;font-size:.875rem}.h6{font-size:12px;font-size:.75rem}.font-family-inherit{font-family:inherit}.font-size-inherit{font-size:inherit}.text-decoration-none{text-decoration:none}.bold{font-weight:700}.regular{font-weight:400}.italic{font-style:italic}.caps{text-transform:uppercase;letter-spacing:.2em}.left-align{text-align:left}.center{text-align:center}.right-align{text-align:right}.justify{text-align:justify}.nowrap{white-space:nowrap}.break-word{word-wrap:break-word}.line-height-1{line-height:1}.line-height-2{line-height:1.125}.line-height-3{line-height:1.25}.line-height-4{line-height:1.5}.list-style-none{list-style:none}.underline{text-decoration:underline}.truncate{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.list-reset{list-style:none;padding-left:0}.inline{display:inline}.block{display:block}.inline-block{display:inline-block}.table{display:table}.table-cell{display:table-cell}.overflow-hidden{overflow:hidden}.overflow-scroll{overflow:scroll}.overflow-auto{overflow:auto}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.left{float:left}.right{float:right}.fit{max-width:100%}.max-width-1{max-width:384px;max-width:24rem}.max-width-2{max-width:512px;max-width:32rem}.max-width-3{max-width:768px;max-width:48rem}.max-width-4{max-width:1024px;max-width:64rem}.border-box{box-sizing:border-box}.align-baseline{vertical-align:baseline}.align-top{vertical-align:top}.align-middle{vertical-align:middle}.align-bottom{vertical-align:bottom}.m0{margin:0}.mt0{margin-top:0}.mr0{margin-right:0}.mb0{margin-bottom:0}.ml0,.mx0{margin-left:0}.mx0{margin-right:0}.my0{margin-top:0;margin-bottom:0}.m1{margin:8px;margin:.5rem}.mt1{margin-top:8px;margin-top:.5rem}.mr1{margin-right:8px;margin-right:.5rem}.mb1{margin-bottom:8px;margin-bottom:.5rem}.ml1,.mx1{margin-left:8px;margin-left:.5rem}.mx1{margin-right:8px;margin-right:.5rem}.my1{margin-top:8px;margin-top:.5rem;margin-bottom:8px;margin-bottom:.5rem}.m2{margin:16px;margin:1rem}.mt2{margin-top:16px;margin-top:1rem}.mr2{margin-right:16px;margin-right:1rem}.mb2{margin-bottom:16px;margin-bottom:1rem}.ml2,.mx2{margin-left:16px;margin-left:1rem}.mx2{margin-right:16px;margin-right:1rem}.my2{margin-top:16px;margin-top:1rem;margin-bottom:16px;margin-bottom:1rem}.m3{margin:32px;margin:2rem}.mt3{margin-top:32px;margin-top:2rem}.mr3{margin-right:32px;margin-right:2rem}.mb3{margin-bottom:32px;margin-bottom:2rem}.ml3,.mx3{margin-left:32px;margin-left:2rem}.mx3{margin-right:32px;margin-right:2rem}.my3{margin-top:32px;margin-top:2rem;margin-bottom:32px;margin-bottom:2rem}.m4{margin:64px;margin:4rem}.mt4{margin-top:64px;margin-top:4rem}.mr4{margin-right:64px;margin-right:4rem}.mb4{margin-bottom:64px;margin-bottom:4rem}.ml4,.mx4{margin-left:64px;margin-left:4rem}.mx4{margin-right:64px;margin-right:4rem}.my4{margin-top:64px;margin-top:4rem;margin-bottom:64px;margin-bottom:4rem}.mxn1{margin-left:-8px;margin-left:-.5rem;margin-right:-8px;margin-right:-.5rem}.mxn2{margin-left:-16px;margin-left:-1rem;margin-right:-16px;margin-right:-1rem}.mxn3{margin-left:-32px;margin-left:-2rem;margin-right:-32px;margin-right:-2rem}.mxn4{margin-left:-64px;margin-left:-4rem;margin-right:-64px;margin-right:-4rem}.ml-auto{margin-left:auto}.mr-auto,.mx-auto{margin-right:auto}.mx-auto{margin-left:auto}.p0{padding:0}.pt0{padding-top:0}.pr0{padding-right:0}.pb0{padding-bottom:0}.pl0,.px0{padding-left:0}.px0{padding-right:0}.py0{padding-top:0;padding-bottom:0}.p1{padding:8px;padding:.5rem}.pt1{padding-top:8px;padding-top:.5rem}.pr1{padding-right:8px;padding-right:.5rem}.pb1{padding-bottom:8px;padding-bottom:.5rem}.pl1{padding-left:8px;padding-left:.5rem}.py1{padding-top:8px;padding-top:.5rem;padding-bottom:8px;padding-bottom:.5rem}.px1{padding-left:8px;padding-left:.5rem;padding-right:8px;padding-right:.5rem}.p2{padding:16px;padding:1rem}.pt2{padding-top:16px;padding-top:1rem}.pr2{padding-right:16px;padding-right:1rem}.pb2{padding-bottom:16px;padding-bottom:1rem}.pl2{padding-left:16px;padding-left:1rem}.py2{padding-top:16px;padding-top:1rem;padding-bottom:16px;padding-bottom:1rem}.px2{padding-left:16px;padding-left:1rem;padding-right:16px;padding-right:1rem}.p3{padding:32px;padding:2rem}.pt3{padding-top:32px;padding-top:2rem}.pr3{padding-right:32px;padding-right:2rem}.pb3{padding-bottom:32px;padding-bottom:2rem}.pl3{padding-left:32px;padding-left:2rem}.py3{padding-top:32px;padding-top:2rem;padding-bottom:32px;padding-bottom:2rem}.px3{padding-left:32px;padding-left:2rem;padding-right:32px;padding-right:2rem}.p4{padding:64px;padding:4rem}.pt4{padding-top:64px;padding-top:4rem}.pr4{padding-right:64px;padding-right:4rem}.pb4{padding-bottom:64px;padding-bottom:4rem}.pl4{padding-left:64px;padding-left:4rem}.py4{padding-top:64px;padding-top:4rem;padding-bottom:64px;padding-bottom:4rem}.px4{padding-left:64px;padding-left:4rem;padding-right:64px;padding-right:4rem}.col{float:left}.col,.col-right{box-sizing:border-box}.col-right{float:right}.col-1{width:8.33333%}.col-2{width:16.66667%}.col-3{width:25%}.col-4{width:33.33333%}.col-5{width:41.66667%}.col-6{width:50%}.col-7{width:58.33333%}.col-8{width:66.66667%}.col-9{width:75%}.col-10{width:83.33333%}.col-11{width:91.66667%}.col-12{width:100%}@media (min-width:40em){.sm-col{float:left;box-sizing:border-box}.sm-col-right{float:right;box-sizing:border-box}.sm-col-1{width:8.33333%}.sm-col-2{width:16.66667%}.sm-col-3{width:25%}.sm-col-4{width:33.33333%}.sm-col-5{width:41.66667%}.sm-col-6{width:50%}.sm-col-7{width:58.33333%}.sm-col-8{width:66.66667%}.sm-col-9{width:75%}.sm-col-10{width:83.33333%}.sm-col-11{width:91.66667%}.sm-col-12{width:100%}}@media (min-width:52em){.md-col{float:left;box-sizing:border-box}.md-col-right{float:right;box-sizing:border-box}.md-col-1{width:8.33333%}.md-col-2{width:16.66667%}.md-col-3{width:25%}.md-col-4{width:33.33333%}.md-col-5{width:41.66667%}.md-col-6{width:50%}.md-col-7{width:58.33333%}.md-col-8{width:66.66667%}.md-col-9{width:75%}.md-col-10{width:83.33333%}.md-col-11{width:91.66667%}.md-col-12{width:100%}}@media (min-width:64em){.lg-col{float:left;box-sizing:border-box}.lg-col-right{float:right;box-sizing:border-box}.lg-col-1{width:8.33333%}.lg-col-2{width:16.66667%}.lg-col-3{width:25%}.lg-col-4{width:33.33333%}.lg-col-5{width:41.66667%}.lg-col-6{width:50%}.lg-col-7{width:58.33333%}.lg-col-8{width:66.66667%}.lg-col-9{width:75%}.lg-col-10{width:83.33333%}.lg-col-11{width:91.66667%}.lg-col-12{width:100%}}.flex{display:-webkit-flex;display:-ms-flexbox;display:flex}@media (min-width:40em){.sm-flex{display:-webkit-flex;display:-ms-flexbox;display:flex}}@media (min-width:52em){.md-flex{display:-webkit-flex;display:-ms-flexbox;display:flex}}@media (min-width:64em){.lg-flex{display:-webkit-flex;display:-ms-flexbox;display:flex}}.flex-column{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.flex-wrap{-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.items-start{-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start}.items-end{-webkit-align-items:flex-end;-ms-flex-align:end;align-items:flex-end}.items-center{-webkit-align-items:center;-ms-flex-align:center;align-items:center}.items-baseline{-webkit-align-items:baseline;-ms-flex-align:baseline;align-items:baseline}.items-stretch{-webkit-align-items:stretch;-ms-flex-align:stretch;align-items:stretch}.self-start{-webkit-align-self:flex-start;-ms-flex-item-align:start;align-self:flex-start}.self-end{-webkit-align-self:flex-end;-ms-flex-item-align:end;align-self:flex-end}.self-center{-webkit-align-self:center;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center}.self-baseline{-webkit-align-self:baseline;-ms-flex-item-align:baseline;align-self:baseline}.self-stretch{-webkit-align-self:stretch;-ms-flex-item-align:stretch;-ms-grid-row-align:stretch;align-self:stretch}.justify-start{-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}.justify-end{-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end}.justify-center{-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.justify-between{-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.justify-around{-webkit-justify-content:space-around;-ms-flex-pack:distribute;justify-content:space-around}.content-start{-webkit-align-content:flex-start;-ms-flex-line-pack:start;align-content:flex-start}.content-end{-webkit-align-content:flex-end;-ms-flex-line-pack:end;align-content:flex-end}.content-center{-webkit-align-content:center;-ms-flex-line-pack:center;align-content:center}.content-between{-webkit-align-content:space-between;-ms-flex-line-pack:justify;align-content:space-between}.content-around{-webkit-align-content:space-around;-ms-flex-line-pack:distribute;align-content:space-around}.content-stretch{-webkit-align-content:stretch;-ms-flex-line-pack:stretch;align-content:stretch}.flex-auto{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;min-width:0;min-height:0}.flex-none{-webkit-flex:none;-ms-flex:none;flex:none}.order-0{-webkit-order:0;-ms-flex-order:0;order:0}.order-1{-webkit-order:1;-ms-flex-order:1;order:1}.order-2{-webkit-order:2;-ms-flex-order:2;order:2}.order-3{-webkit-order:3;-ms-flex-order:3;order:3}.order-last{-webkit-order:99999;-ms-flex-order:99999;order:99999}.relative{position:relative}.absolute{position:absolute}.fixed{position:fixed}.top-0{top:0}.right-0{right:0}.bottom-0{bottom:0}.left-0{left:0}.z1{z-index:1}.z2{z-index:2}.z3{z-index:3}.z4{z-index:4}.border{border-style:solid;border-width:1px}.border-top{border-top-style:solid;border-top-width:1px}.border-right{border-right-style:solid;border-right-width:1px}.border-bottom{border-bottom-style:solid;border-bottom-width:1px}.border-left{border-left-style:solid;border-left-width:1px}.border-none{border:0}.rounded{border-radius:3px}.circle{border-radius:50%}.rounded-top{border-radius:3px 3px 0 0}.rounded-right{border-radius:0 3px 3px 0}.rounded-bottom{border-radius:0 0 3px 3px}.rounded-left{border-radius:3px 0 0 3px}.not-rounded{border-radius:0}.hide{position:absolute!important;height:1px;width:1px;overflow:hidden;clip:rect(1px,1px,1px,1px)}@media (max-width:40em){.xs-hide{display:none!important}}@media (min-width:40em) and (max-width:52em){.sm-hide{display:none!important}}@media (min-width:52em) and (max-width:64em){.md-hide{display:none!important}}@media (min-width:64em){.lg-hide{display:none!important}}.display-none{display:none!important}", ""]);
	
	// exports


/***/ },

/***/ 634:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(459);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(633)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?-minimize!../../node_modules/postcss-loader/index.js!./index.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?-minimize!../../node_modules/postcss-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }

});


// WEBPACK FOOTER //
// main.e0cac6f7815aeadc96ca.js